import _ from "lodash";
import React from "react";

import styled from "styled-components";
const Container = styled.div`
  padding: 50px 25px 50px 25px;
`;
const Message = styled.div`
  color: #9a9a9a;
  font-size: 1em;
  text-align: center;
`;

const EmptyPlaceholder = (props) => {
  return (
    <Container>
      <Message>
        {_.get(props, "filter", "").length > 0
          ? `No matching ${props.itemType} found`
          : `No ${props.itemType}`}
      </Message>
    </Container>
  );
};

export default EmptyPlaceholder;
